import React from "react";
import "./box.css";
import img from "../../../assets/img.png";
 
const Box = () => {

  return (
       <div className="box">
        <div className="text-container">
          <div className="title11">Welcome to Snáithe</div>
          <h2 className="box-second-titles">
            Pioneering Global Industrial Excellence
          </h2>
          <div className="box-1-text">
            Embark on an extraordinary voyage through the realms of Snáithe, an
            avant-garde powerhouse headquartered in Sweden, orchestrating a
            symphony of diverse business sectors with unparalleled finesse. At
            the core of our dynamic ecosystem, Snáithe proudly hosts the top 10
            World Famous Brands, each exemplifying an unwavering commitment to
            attaining the zenith of excellence. Our landscape transcends the
            ordinary; aspirations undergo metamorphic processes, emerging as
            resounding achievements; challenges undergo alchemical
            transformations into golden opportunities; and the exceptional
            becomes the unequivocal norm of operation.
            <br />
            <br />
            Nestled within our multifaceted enterprise resides Snáithe, a name
            harmonizing integrity, trust, and unwavering commitment in perfect
            unison. More than a corporate entity, Snáithe stands as an
            indomitable cornerstone upon which individuals and industries sculpt
            their destinies. Our name bequeaths a legacy of unassailable
            reliability, meticulously cultivated over years of ceaseless
            dedication to delivering unparalleled products and services that
            consistently surpass even the loftiest of expectations.
            </div>
      </div>
      <div className="image-container-right-1">
          <img src={img} alt="Square Image" />
        </div>
    </div>
  );
};

export default Box;
